import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { LocaleProvider } from '@/core/i18n/LocaleProvider';
import { SessionProvider } from '@/core/auth/SessionProvider';
import { NetworkError } from '@/core/api/errors';
import { router } from './router';

/**
 * Cache posture (approved architecture §4): memory-only Query cache, tiered
 * staleness set per query; GETs retry only on network failure (max 2 with
 * backoff), mutations never auto-retry.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => error instanceof NetworkError && failureCount < 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 4000),
    },
    mutations: { retry: 0 },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </LocaleProvider>
    </QueryClientProvider>
  );
}
